<template lang="pug">
.button(@click="click($event)", :class="{ disabled: disabled }")
  slot
</template>

<script>
export default {
  props: ["disabled"],
  methods: {
    click(event) {
      if (!this.disabled) this.$emit("click", event);
    },
  },
};
</script>

<style lang="less" scoped>
@import (reference) "../shared.less";

.button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #000;
  font-weight: bold;
  background: linear-gradient(-45deg, #aaa, #fff);
  padding: 0.3rem;
  font-size: 1.2rem;
  border: 1px solid #888;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  border-radius: 0.5rem;
  box-shadow: #777 0.1rem 0.1rem 0.2rem;

  &:not(.disabled):hover {
	  background: linear-gradient(-45deg, #222, #ddd);
	  color: #fff;
  }

  &:active {
    box-shadow: none;
    background: linear-gradient(180deg, #ccc, #fff);
    -webkit-transform: translate(0, 2px);
    -moz-transform: translate(0, 2px);
    transform: translate(0, 2px);
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
  }
  &.selected {
    color: #080;
    border-width: 1px;
    border-color: black;
    background: linear-gradient(180deg, #cec, #fff);
    box-shadow: none;
    transform: translate(0, 2px);
  }
  &.disabled {
    color: #aaa;
    cursor: default;
	pointer-events: none;
    border-color: #ccc;
    box-shadow: ccc 0.1rem 0.1rem 0.2rem;
  }

}

</style>